module.exports = new __parcel__URL__("testimonial-david-bellaiche.e487dcaf.webp").toString();